export default {
  heading: "登入資訊",
  accountSelect:{
    heading:"請選擇您想要變更的登入資訊",
    cityId:"校本帳戶",
    email:"會員帳戶",
  }
};
